type OpenPreviewWindow = (
  url?: string | URL,
  target?: string,
  features?: string,
) => Window | null;

export function reservePreviewWindow(
  openWindow: OpenPreviewWindow = window.open.bind(window),
): Window | null {
  const previewWindow = openWindow("about:blank", "_blank");
  if (!previewWindow) return null;
  try {
    previewWindow.opener = null;
    previewWindow.document.title = "Preparing exact branding preview…";
  } catch {
    // The reserved window remains usable even when a browser blocks metadata writes.
  }
  return previewWindow;
}

export function navigateReservedPreviewWindow(
  previewWindow: Window | null,
  callbackUrl: string,
): boolean {
  if (!previewWindow || previewWindow.closed) return false;
  try {
    previewWindow.location.replace(callbackUrl);
    return true;
  } catch {
    return false;
  }
}

export function closeReservedPreviewWindow(previewWindow: Window | null): void {
  if (!previewWindow || previewWindow.closed) return;
  try {
    previewWindow.close();
  } catch {
    // Best effort only; failures must not mask the governed API error.
  }
}
